export const styles = (theme) => ({
    title: {
        "& h4": {
            margin: "1.5rem 0 0.5rem 0"
        }
    },
    sectionInput: {
        margin: "25px 0 0 0",
        "& span": {
            fontWeight: "bold",
            display: "block"
        }
    },
    exportButton: {
        padding: "5px 0px"
    },
    formControl: {
        width: "100%"
    },
    errorText: {
        color: "red"
    },
    blackText: {
        color: "black"
    },
    content: {
        padding: "10px 20px 20px 20px",
    },
    center: {
        textAlign: "center" as const
    },
});
